import styled from 'styled-components';

import { Flex } from '@/components/Flex';

export const Header = styled(Flex)`
  width: 100%;
  flex-direction: column;
  align-items: start;
  margin-left: ${({ theme }) => theme.spacing(4)};
`;

export const HeaderText = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.h2};
`;

export const Body = styled(Flex)`
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(4)};
`;

export const Oney3xBadge = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  border-radius: 50%;
`;
